import React, { useState, useEffect, useRef } from "react";
import "./ticketdashboard.css";
import Chatbox from "../components/Chat&assign/Chatbox";
import Marquee from "react-fast-marquee";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { motion } from "framer-motion";
import { FaRegUserCircle, FaInfoCircle } from "react-icons/fa";

function Support() {
  const [supporttickets, setSupportTickets] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [messages, setMessages] = useState([]);

  const [newMessage, setNewMessage] = useState("");
  const rowsPerPage = 10;
  const [isOpen, setIsOpen] = useState(false);
  const [isOpen1, setIsOpen1] = useState(true);
  const [currentPageOpened, setCurrentPageOpened] = useState(1);
  const [currentPageClosed, setCurrentPageClosed] = useState(1);
  const openedTickets = supporttickets.filter(
    (ticket) => ticket.status !== "Closed"
  );
  const closedTickets = supporttickets.filter(
    (ticket) => ticket.status === "Closed"
  );
  const totalPagesOpened = Math.ceil(openedTickets.length / rowsPerPage);
  const startIndexOpened = (currentPageOpened - 1) * rowsPerPage;
  const currentRowsOpened = openedTickets.slice(
    startIndexOpened,
    startIndexOpened + rowsPerPage
  );

  const totalPagesClosed = Math.ceil(closedTickets.length / rowsPerPage);
  const startIndexClosed = (currentPageClosed - 1) * rowsPerPage;
  const currentRowsClosed = closedTickets.slice(
    startIndexClosed,
    startIndexClosed + rowsPerPage
  );

  const userDetails = JSON.parse(localStorage.getItem("userdetails"));

  const handleInputChange = (e) => {
    setNewMessage(e.target.value);
  };

  const handleViewClick = (row) => {
    setSelectedRow(row); // still sets the row for the modal
    setIsModalOpen(true);
    // fetchMessages(row.ticketId);
    if (row.status === "Assigned") {
      handlestatusopen(row.ticketId);
    }
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedRow(null);
    setMessages([]);
  };

  const fetchsupportTickets = async () => {
    const apiUrl = `${process.env.REACT_APP_BASEURL}/apis/getsupportticket.php`;
    const formData = new FormData();

    // Append form data
    formData.append("id", userDetails.id);
    formData.append("sub", userDetails.sub);
    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        body: formData,
      });
      const data = await response.json();
      if (data.message === "Records fetched successfully") {
        setSupportTickets(data.data);
      }
    } catch (error) {
      console.log("Error fetching tickets:", error);
    }
  };

  useEffect(() => {
    fetchsupportTickets();
  }, []);

  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const menuRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsMenuOpen(false);
        // setaddactpopup(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // const fetchMessages = async (ticketNumber) => {
  //   try {
  //     const apiUrl = `${process.env.REACT_APP_BASEURL}/apis/getmsg.php`;
  //     const formData = new FormData();
  //     formData.append("ticket_number", ticketNumber); // adjust based on backend param

  //     const response = await fetch(apiUrl, {
  //       method: "POST",
  //       body: formData,
  //     });

  //     const data = await response.json();

  //     if (response.ok && data.message === "Records fetched successfully") {
  //       setMessages(data.data); // Assuming backend returns message array in `data`
  //     } else {
  //       setMessages([]);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching messages:", error);
  //     setMessages([]);
  //   }
  // };
  const handlestatus = async (status) => {
    console.log("Ticket status changed to:", status);

    if (!selectedRow || !selectedRow.ticketId) {
      toast.error("No ticket selected.");
      return;
    }

    try {
      const apiUrl = `${process.env.REACT_APP_BASEURL}/apis/status.php`;
      const formData = new FormData();
      formData.append("id", selectedRow.ticketId);
      formData.append("status", status);
      formData.append("clsid", userDetails.id);

      const response = await fetch(apiUrl, {
        method: "POST",
        body: formData,
      });

      const data = await response.json();

      if (response.ok) {
        toast.success(`Ticket status has been updated to ${status}`);
        fetchsupportTickets(); // refresh list
        closeModal(); // close modal
      } else {
        toast.error(data?.message || "An unexpected error occurred.");
      }
    } catch (error) {
      console.error("Error updating status:", error);
      toast.error("An error occurred while updating the status.");
    }
  };

  const handlestatusopen = async (ticketId) => {
    if (!ticketId) {
      toast.error("No ticket selected.");
      return;
    }

    try {
      const formData = new FormData();
      formData.append("id", ticketId);

      const response = await fetch(
        `${process.env.REACT_APP_BASEURL}/apis/statusopen.php`,
        {
          method: "POST",
          body: formData,
        }
      );

      const data = await response.json();

      if (response.ok) {
        toast.success("Ticket status has been updated to Opened");
        fetchsupportTickets(); // refresh ticket list
      } else {
        toast.error(data?.message || "An unexpected error occurred.");
      }
    } catch (error) {
      console.error("Error updating status:", error);
      toast.error("An error occurred while updating the status.");
    }
  };

  const boxRef1 = useRef(null);
  const boxRef2 = useRef(null);

  // Function to scroll to a specific box (you can pass a ref to scroll to different boxes)
  const scrollToBox = (targetRef) => {
    if (targetRef.current) {
      targetRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <div>
      <div className="center">
        <div className="menu-position">
          <div></div>
          <br />
          <h1 className="h1">Support Portal</h1>
          <div className="welcome_tag">
            <span>
              <div className="marquee-container">
                <Marquee
                  speed={40}
                  direction="right"
                  pauseOnHover
                  gradient={false}
                >
                  {userDetails.username}
                </Marquee>
              </div>
            </span>
            <div className="profile_icon">
              <FaRegUserCircle />
            </div>
          </div>
        </div>
      </div>

      {/* tickets cards */}
      <div className="ticket-summary">
        <div className="ticket-card">
          <span>Total Tickets:</span>
          <span>{supporttickets.length}</span>
        </div>

        <div className="ticket-card">
          <span>Assigned Tickets:</span>
          <span>
            {
              supporttickets.filter((ticket) => ticket.status === "Assigned")
                .length
            }
          </span>
        </div>

        <div className="ticket-card">
          <span>Opened Tickets:</span>
          <span>
            {
              supporttickets.filter((ticket) => ticket.status === "Opened")
                .length
            }
          </span>
        </div>

        <div className="ticket-card">
          <span>Hold Tickets:</span>
          <span>
            {supporttickets.filter((ticket) => ticket.status === "Hold").length}
          </span>
        </div>

        <div className="ticket-card">
          <span>Closed Tickets:</span>
          <span>{closedTickets.length}</span>
        </div>
      </div>

      {/* opened  */}
      <div>
        <div style={{ display: "flex", justifyContent: "center" }}>
          <button
            onClick={() => {
              setIsOpen1(!isOpen1);
              setIsOpen(false);
            }}
            style={{
              background: "grey",
              padding: "8px 16px",
              borderRadius: "5px",
              color: "white",
              cursor: "pointer",
            }}
          >
            PENDING TICKETS
          </button>
        </div>

        <motion.div
          initial={{ height: "auto", opacity: 1 }}
          animate={{ height: isOpen1 ? "auto" : 0, opacity: isOpen1 ? 1 : 0 }}
          transition={{ duration: 0.5 }}
          style={{
            overflow: "hidden",
            padding: isOpen1 ? "10px" : "0px",
            borderRadius: "5px",
            marginTop: "10px",
          }}
        >
          <div className="tda">
            <div className="tdb">
              <div className="scroll">
                <div className="tdc">
                  <table border="1" className="tdd">
                    <thead className="tde">
                      <tr>
                        <th className="tdf">Serial No</th>
                        <th className="tdf">Employee Name</th>
                        <th className="tdf">Ticket Number</th>
                        <th className="tdf">Error Tittle</th>
                        <th className="tdf">View</th>
                        <th className="tdf">Status</th>

                        {["admin", "imanager", "icoordinator"].includes(
                          userDetails?.role
                        ) && <th className="tdf">Assigned Name</th>}
                        {["admin", "imanager", "icoordinator"].includes(
                          userDetails?.role
                        ) && <th className="tdf">Assign</th>}
                      </tr>
                    </thead>
                    <tbody className="tdg">
                      {currentRowsOpened.length > 0 ? (
                        currentRowsOpened.map((ticket, index) => (
                          <tr key={ticket.id}>
                            <td className="tdh">
                              {startIndexOpened + index + 1}.
                            </td>
                            {/* <td>{ticket.email}</td> */}
                            <td className="tdh">{ticket.name}</td>
                            <td className="tdh">{ticket.ticketnumber}</td>
                            <td className="tdh">{ticket.e_title}</td>
                            {/* <td>{ticket.files}</td> */}
                            <td className="tdh">
                              <button
                                className="tdi"
                                onClick={() =>
                                  handleViewClick({
                                    ticketId: ticket.id,
                                    ticketNumber: ticket.ticketnumber,
                                    employeeName: ticket.name,
                                    clientEmail: ticket.email,
                                    ph: ticket.contactnumber,
                                    title: ticket.e_title,
                                    errorDescription: ticket.e_des,
                                    file: ticket.files,
                                    status: ticket.status,
                                    res_tym: ticket.res_time,
                                    create: ticket.created_at,
                                    remarks: ticket.remarks,
                                  })
                                }
                              >
                                View
                              </button>
                            </td>
                            <td className="tdh">{ticket.status}</td>

                            {/* <div className="radio-inputs">
                        {["Opened", "In Process", "Hold", "Closed"].map(
                          (status, idx) => (
                            <label key={idx} className="radio">
                              <input
                                name={`radio-${ticket.id}`}
                                type="radio"
                                defaultChecked={idx === 0}
                              />
                              <span className={`name${idx + 1}`}>{status}</span>
                            </label>
                          )
                        )}
                      </div> */}
                            {/* </td> */}
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td className="tdh" colSpan="8">
                            No tickets available
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            {totalPagesOpened > 1 && (
              <div className="tdj">
                <div>
                  <h2 className="tdk">
                    Page {currentPageOpened} of {totalPagesOpened}
                  </h2>

                  <div className="tdl">
                    {currentPageOpened !== 1 && (
                      <>
                        <button
                          className="tdm"
                          onClick={() => setCurrentPageOpened(1)}
                        >
                          &laquo; First page
                        </button>

                        <button
                          className="tdm"
                          onClick={() =>
                            setCurrentPageOpened((prev) =>
                              Math.max(prev - 1, 1)
                            )
                          }
                        >
                          &lt; Previous
                        </button>
                      </>
                    )}

                    {currentPageOpened !== totalPagesOpened && (
                      <>
                        <button
                          className="tdn"
                          onClick={() =>
                            setCurrentPageOpened((prev) =>
                              Math.min(prev + 1, totalPagesOpened)
                            )
                          }
                        >
                          Next &gt;
                        </button>

                        <button
                          className="tdo"
                          onClick={() => setCurrentPageOpened(totalPagesOpened)}
                        >
                          Last page &raquo;
                        </button>
                      </>
                    )}
                  </div>
                </div>
              </div>
            )}

            {isModalOpen && selectedRow && (
              <div className="tdp">
                <div className="tdr">
                  <div className="tds-container">
                    <div className="tds" ref={boxRef1}>
                      <h2 className="tdt">Ticket Details</h2>

                      <div className="tinfo-container">
                        <div className="tinfo-ticket-wrapper">
                          <p className="tinfo-ticket-number">
                            <strong>{selectedRow.ticketNumber}</strong>

                            <span className="tinfo-icon-wrapper">
                              {/* <FaInfoCircle className="tinfo-icon" /> */}
                              <span className="tinfo-tooltip">
                                Ticket Created: {selectedRow.ticketcreatedtym}{" "}
                                <br />
                                {["Hold", "Opened"].includes(
                                  selectedRow?.status
                                ) &&
                                  `Ticket Opened: ${
                                    selectedRow.res_tym ===
                                      "0000-00-00 00:00:00" ||
                                    !selectedRow.res_tym
                                      ? "-"
                                      : selectedRow.res_tym
                                  }`}
                              </span>
                            </span>
                          </p>
                        </div>

                        {/* Employee info row */}

                        <div className="tinfo-employee-row">
                          <p className="tinfo-field">
                            <strong className="tinfo-label">
                              Employee Name:
                            </strong>
                            <br />
                            {selectedRow.employeeName}
                          </p>
                          <p className="tinfo-field">
                            <strong className="tinfo-label">
                              Employee Email:
                            </strong>
                            <br />
                            {selectedRow.clientEmail}
                          </p>
                          <p className="tinfo-field">
                            <strong className="tinfo-label">
                              Contact Number:
                            </strong>
                            <br />
                            {selectedRow.ph}
                          </p>
                        </div>

                        <div className="tinfo-employee-row">
                          <p className="tinfo-field">
                            <strong className="tinfo-label">
                              Error Title:
                            </strong>
                            <br />
                            {selectedRow.title}
                          </p>
                          {selectedRow.remarks && (
                            <p className="tinfo-field">
                              <strong className="tinfo-label">Remarks:</strong>
                              <br />
                              {selectedRow.remarks}
                            </p>
                          )}
                        </div>

                        <p className="tinfo-field">
                          <strong className="tinfo-label">
                            Error Description:
                          </strong>
                          <br />
                          {selectedRow.errorDescription}
                        </p>

                        {selectedRow.file && (
                          <p className="tinfo-field">
                            <strong className="tinfo-label">File:</strong>
                            <br />
                            <a
                              href={`${process.env.REACT_APP_BASEURL}/apis/uploads/${selectedRow.file}`}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="tinfo-file-link"
                            >
                              {selectedRow.file}
                            </a>
                          </p>
                        )}
                      </div>
                    </div>

                    <div className="chatbox-wrapper">
                      <Chatbox
                        selectedRowID={selectedRow.ticketId} // OR searchedTicketId="TIC-2025-00123"
                        selectedEmail={selectedRow.clientEmail}
                        status={selectedRow.status}
                        ticketclosed={selectedRow.closed_time}
                        ticketassign={selectedRow.asname}
                      />
                      <div className="btn-container">
                        <button
                          className="ticket-details-btn"
                          onClick={() => scrollToBox(boxRef1)}
                        >
                          Ticket Details
                        </button>

                        {userDetails?.role != "cmanager" &&
                          userDetails?.role != "user" && (
                            <div className="tdx">
                              {selectedRow.status === "Hold" ? (
                                <button
                                  className="tdz"
                                  onClick={() => handlestatus("Closed")}
                                >
                                  Closed
                                </button>
                              ) : (
                                <>
                                  <button
                                    className="tdy"
                                    onClick={() => handlestatus("Hold")}
                                  >
                                    Hold
                                  </button>
                                  <button
                                    className="tdz"
                                    onClick={() => handlestatus("Closed")}
                                  >
                                    Closed
                                  </button>
                                </>
                              )}
                            </div>
                          )}
                      </div>
                      {/* <Chatbox /> */}

                      {/* <div className="chat-container">
                      <h2>Update with Support</h2>
                      <div className="chat-box">
                        {messages.map((msg, index) => (
                          <div
                            key={index}
                            className={
                              msg.sender === "Employee"
                                ? "chat-message employee"
                                : "chat-message client"
                            }
                          >
                            <strong>{msg.sender}: </strong>
                            {msg.message}
                          </div>
                        ))}
                      </div>
                      <div className="chat-input">
                        <input
                          type="text"
                          value={newMessage}
                          onChange={handleInputChange}
                          placeholder="Type your message here..."
                        />
                        <button className="sendbn" onClick={handleSendMessage}>
                          Send
                        </button>
                      </div>
                    </div> */}
                    </div>
                  </div>

                  <div className="tdq" onClick={closeModal}>
                    &times;
                  </div>
                </div>
              </div>
            )}
          </div>
        </motion.div>
      </div>

      {/* closed  */}
      <div>
        <div style={{ display: "flex", justifyContent: "center" }}>
          <button
            onClick={() => {
              setIsOpen(!isOpen);
              setIsOpen1(false);
            }}
            style={{
              background: "grey",
              padding: "8px 16px",
              borderRadius: "5px",
              color: "white",
              cursor: "pointer",
            }}
            className="closed"
          >
            CLOSED TICKETS
          </button>
        </div>

        <motion.div
          initial={{ height: "auto", opacity: 1 }}
          animate={{ height: isOpen ? "auto" : 0, opacity: isOpen ? 1 : 0 }}
          transition={{ duration: 0.5 }}
          style={{
            overflow: "hidden",
            padding: isOpen ? "10px" : "0px",
            borderRadius: "5px",
            marginTop: "10px",
          }}
        >
          <div className="tda">
            <div className="tdb">
              <div className="scroll">
                <div className="tdc">
                  <table border="1" className="tdd">
                    <thead className="tde">
                      <tr>
                        <th className="tdf">Serial No</th>
                        {/* <th>Client Email</th> */}
                        <th className="tdf">Employee Name</th>
                        <th className="tdf">Ticket Number</th>
                        <th className="tdf">Error Tittle</th>
                        {/* <th>file</th> */}
                        <th className="tdf">View</th>
                        <th className="tdf">Status</th>
                      </tr>
                    </thead>
                    <tbody className="tdg">
                      {currentRowsClosed.length > 0 ? (
                        currentRowsClosed.map((supportticket, index) => (
                          <tr key={supportticket.id}>
                            <td className="tdh">
                              {startIndexClosed + index + 1}.
                            </td>
                            {/* <td>{ticket.email}</td> */}
                            <td className="tdh">{supportticket.name}</td>
                            <td className="tdh">
                              {supportticket.ticketnumber}
                            </td>
                            <td className="tdh">{supportticket.e_title}</td>
                            {/* <td>{ticket.files}</td> */}
                            <td className="tdh">
                              <button
                                className="tdi"
                                onClick={() =>
                                  handleViewClick({
                                    ticketId: supportticket.id,
                                    ticketNumber: supportticket.ticketnumber,
                                    employeeName: supportticket.name,
                                    clientEmail: supportticket.email,
                                    ph: supportticket.ph,
                                    title: supportticket.e_title,
                                    errorDescription: supportticket.e_des,
                                    file: supportticket.files,
                                    status: supportticket.status,
                                    asname: supportticket.asname,
                                    create: supportticket.created_at,
                                    res_time: supportticket.res_time,
                                    closed_time: supportticket.close_time,
                                    closed_by: supportticket.clsname,
                                    remarks: supportticket.remarks,
                                  })
                                }
                              >
                                View
                              </button>
                            </td>
                            <td className="tdh">
                              {supportticket.status}
                              {/* <div className="radio-inputs">
                        {["Opened", "In Process", "Hold", "Closed"].map(
                          (status, idx) => (
                            <label key={idx} className="radio">
                              <input
                                name={`radio-${ticket.id}`}
                                type="radio"
                                defaultChecked={idx === 0}
                              />
                              <span className={`name${idx + 1}`}>{status}</span>
                            </label>
                          )
                        )}
                      </div> */}
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td className="tdh" colSpan="8">
                            No tickets available
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            {totalPagesClosed > 1 && (
              <div className="tdj">
                <div>
                  <h2 className="tdk">
                    Page {currentPageClosed} of {totalPagesClosed}
                  </h2>

                  <div className="tdl">
                    {currentPageClosed !== 1 && (
                      <>
                        <button
                          className="tdm"
                          onClick={() => setCurrentPageClosed(1)}
                        >
                          &laquo; First page
                        </button>

                        <button
                          className="tdm"
                          onClick={() =>
                            setCurrentPageClosed((prev) =>
                              Math.max(prev - 1, 1)
                            )
                          }
                        >
                          &lt; Previous
                        </button>
                      </>
                    )}

                    {currentPageClosed !== totalPagesClosed && (
                      <>
                        <button
                          className="tdn"
                          onClick={() =>
                            setCurrentPageClosed((prev) =>
                              Math.min(prev + 1, totalPagesClosed)
                            )
                          }
                        >
                          Next &gt;
                        </button>

                        <button
                          className="tdo"
                          onClick={() => setCurrentPageClosed(totalPagesClosed)}
                        >
                          Last page &raquo;
                        </button>
                      </>
                    )}
                  </div>
                </div>
              </div>
            )}

            {isModalOpen && selectedRow && (
              <div className="tdp">
                <div className="tdr">
                  <div className="tds-container">
                    <div className="tds" ref={boxRef2}>
                      <h2 className="tdt">Ticket Details</h2>
                      <div className="tinfo-container">
                        <div className="tinfo-ticket-wrapper">
                          <p className="tinfo-ticket-number">
                            <strong>{selectedRow.ticketNumber}</strong>
                            <span className="tinfo-icon-wrapper">
                              <FaInfoCircle className="tinfo-icon" />
                              <span className="tinfo-tooltip">
                                Ticket Created: {selectedRow.create} <br />
                                Ticket Opened:{" "}
                                {selectedRow.restime ===
                                  "0000-00-00 00:00:00" || !selectedRow.res_time
                                  ? "-"
                                  : selectedRow.res_time}
                              </span>
                            </span>
                          </p>
                        </div>

                        {/* Employee Info Row */}
                        <div className="tinfo-employee-row">
                          <p className="tinfo-field">
                            <strong className="tinfo-label">
                              Employee Name:
                            </strong>
                            <br />
                            {selectedRow.employeeName}
                          </p>

                          <p className="tinfo-field">
                            <strong className="tinfo-label">
                              Employee Email:
                            </strong>
                            <br />
                            {selectedRow.clientEmail}
                          </p>

                          <p className="tinfo-field">
                            <strong className="tinfo-label">
                              Contact Number:
                            </strong>
                            <br />
                            {selectedRow.ph}
                          </p>
                        </div>

                        {/* Error Information */}
                        <div className="tinfo-employee-row">
                          <p className="tinfo-field">
                            <strong className="tinfo-label">
                              Error Title:
                            </strong>
                            <br />
                            {selectedRow.title}
                          </p>
                          {selectedRow.remarks && (
                            <p className="tinfo-field">
                              <strong className="tinfo-label">Remarks:</strong>
                              <br />
                              {selectedRow.remarks}
                            </p>
                          )}
                        </div>

                        <p className="tinfo-field">
                          <strong className="tinfo-label">
                            Error Description:
                          </strong>
                          <br />
                          {selectedRow.errorDescription}
                        </p>

                        {/* File Link */}
                        {selectedRow.file && (
                          <p className="tinfo-field">
                            <strong className="tinfo-label">File:</strong>
                            <br />
                            <a
                              href={`${process.env.REACT_APP_BASEURL}/apis/uploads/${selectedRow.file}`}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="tinfo-file-link"
                            >
                              {selectedRow.file}
                            </a>
                          </p>
                        )}
                      </div>
                    </div>

                    <div className="chatbox-wrapper">
                      <Chatbox
                        selectedRowID={selectedRow.ticketId} // OR searchedTicketId="TIC-2025-00123"
                        selectedEmail={selectedRow.clientEmail}
                        status={selectedRow.status}
                        ticketclosed={selectedRow.closed_time}
                        ticketclosedbyname={selectedRow.closed_by}
                        ticketId={selectedRow.id}
                      />
                      <button
                        className="ticket-details-btn"
                        onClick={() => scrollToBox(boxRef2)}
                      >
                        Ticket Details
                      </button>
                    </div>
                  </div>

                  <div className="tdq" onClick={closeModal}>
                    &times;
                  </div>
                </div>
              </div>
            )}
          </div>
        </motion.div>
      </div>
    </div>
  );
}

export default Support;
